var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.418 10.0005H6.582C6.16587 9.99708 5.76541 10.1591 5.46873 10.4509C5.17204 10.7427 5.00343 11.1404 5 11.5565V17.4455C5.0077 18.3117 5.71584 19.0078 6.582 19.0005H9.418C9.83413 19.004 10.2346 18.842 10.5313 18.5502C10.828 18.2584 10.9966 17.8607 11 17.4445V11.5565C10.9966 11.1404 10.828 10.7427 10.5313 10.4509C10.2346 10.1591 9.83413 9.99708 9.418 10.0005Z",
    stroke: "#3D4C66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.418 4.0006H6.582C5.73326 3.97706 5.02559 4.64492 5 5.4936V6.5076C5.02559 7.35629 5.73326 8.02415 6.582 8.0006H9.418C10.2667 8.02415 10.9744 7.35629 11 6.5076V5.4936C10.9744 4.64492 10.2667 3.97706 9.418 4.0006Z",
    stroke: "#3D4C66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.582 13.0005H17.417C17.8333 13.0043 18.234 12.8424 18.5309 12.5506C18.8278 12.2587 18.9966 11.8608 19 11.4445V5.55654C18.9966 5.14041 18.828 4.74269 18.5313 4.45088C18.2346 4.15907 17.8341 3.99708 17.418 4.00054H14.582C14.1659 3.99708 13.7654 4.15907 13.4687 4.45088C13.172 4.74269 13.0034 5.14041 13 5.55654V11.4445C13.0034 11.8607 13.172 12.2584 13.4687 12.5502C13.7654 12.842 14.1659 13.004 14.582 13.0005Z",
    stroke: "#3D4C66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.582 19.0006H17.417C18.2661 19.0247 18.9744 18.3567 19 17.5076V16.4936C18.9744 15.6449 18.2667 14.9771 17.418 15.0006H14.582C13.7333 14.9771 13.0256 15.6449 13 16.4936V17.5066C13.025 18.3557 13.7329 19.0241 14.582 19.0006Z",
    stroke: "#3D4C66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterIcon);
export default __webpack_public_path__ + "static/media/Register-Icon.7b22f1dce3a9de400c900e1a18dd9052.svg";
export { ForwardRef as ReactComponent };